
export const CONFIGMERCHENT = ["Al-nasruae", "Jaspal189", "Goldennugget88", "sarabetclub", "FoxwoodS", "Maharaja", "step9fbs", "sky9sports",];

export const CONFIGMERCHENTID = [45, 46, 63, 65, 67, 75, 86, 87, 44, 69, 70, 74]; // , 44, 69, 70, 74 เป็นร้าน test ที่ขึ้นต้นด้วย EX.

